function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
DashboardManagerController.$inject = ["activityService", "storageService", "customerEngagementService", "authorizationService", "searchService", "environmentVariables", "dealerService", "assetTypes", "saleTypes"];
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.get-prototype-of.js";
import "core-js/modules/es6.object.set-prototype-of.js";
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* injects from baggage-loader */
require('./dashboard-manager.component.html');
import angular from 'angular';
import moment from 'moment-timezone';
import { ApiActivityTypes } from '../../constants';
import { TimeZonesById, guessBrowserTimeZone } from '../../constants/time-zones';
import { widgetTypes } from '../../constants/widget-types';
import { EngagementEventGroups } from '../../constants/engagement-event-types.constant';
import './dashboard.scss';
angular.module('AaApp.Opp').component('dashboardManager', {
  templateUrl: '/app/components/dashboard/dashboard-manager.component.html',
  controller: DashboardManagerController,
  bindings: {
    selectedDealerId: "<",
    userId: "<"
  }
});
function DashboardManagerController(activityService, storageService, customerEngagementService, authorizationService, searchService, environmentVariables, dealerService, assetTypes, saleTypes) {
  "ngInject";

  var $ctrl = this;
  var MAX_ROWS = environmentVariables.managerDashboardCustomerEngagementMaxRows || 50;
  $ctrl.showHotLeadsOnly = false;
  $ctrl.showNotWorkedOnly = false;
  $ctrl.permissions = {};
  $ctrl.$onChanges = $onChanges;
  $ctrl.closeCallback = closeCallback;
  $ctrl.refreshWidgets = refreshWidgets;
  $ctrl.hotLeadsOnlyChanged = filtersChanged;
  $ctrl.NotWorkedChanged = filtersChanged;
  $ctrl.$onInit = init;
  $ctrl.showReviewPro = false;
  $ctrl.showGeoAlert = false;
  $ctrl.getWidgetColumnTypesList = getWidgetColumnTypesList;
  $ctrl.getWidgetLink = getWidgetLink;
  $ctrl.moveWidgetToTop = moveWidgetToTop;
  $ctrl.setFavoriteWidget = setFavoriteWidget;
  $ctrl.saveCollapseState = saveCollapseState;

  //const standardColumnTypes = ['customerEngagement', 'opportunity', 'alertBlocks'];
  var reviewProColumnTypes = ['customerEngagement', 'opportunity', 'reviewRating'];
  var emailTextOneToOneColumnTypes = ['customerEngagement', 'opportunity', 'groupEngagement', 'alertBlocks', 'emailtext'];
  var serviceColumnTypes = ['customerEngagement', 'opportunity', 'service', 'alertBlocks'];
  var webColumnTypes = ['customerEngagement', 'opportunity', 'web', 'alertBlocks'];
  var geoAlertColumnTypes = ['customerEngagement', 'opportunity', 'geoAlert'];
  var upComingApptColumnTypes = ['customerEngagement', 'opportunity', 'alertBlocks', 'upcoming'];
  var isEuroLite = authorizationService.isEuroLite();

  //TODO:  refactor this to a centralized location.
  //Configuration
  $ctrl.leaseSaleTypes = [saleTypes.lease];
  $ctrl.retailSaleTypes = [saleTypes.retail, saleTypes.balloon];
  function setUpWidgets() {
    return _setUpWidgets.apply(this, arguments);
  }
  function _setUpWidgets() {
    _setUpWidgets = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            $ctrl.widgets = [{
              widgetDefaultOrder: 1,
              widgetType: widgetTypes.opportunitiesTable,
              widgetTitleKey: 'retailWidgetTitle',
              widgetExpandToolTipKey: 'expandretail',
              widgetLink: $ctrl.getWidgetLink('retail'),
              columnTypes: $ctrl.getWidgetColumnTypesList('retail'),
              widgetDataService: retailWidgetDataService,
              triggerRefresh: 0,
              isFavorite: false,
              isCollapsed: false
            }, {
              widgetDefaultOrder: 2,
              widgetType: widgetTypes.opportunitiesTable,
              widgetTitleKey: 'leaseWidgetTitle',
              widgetExpandToolTipKey: 'expandlease',
              widgetLink: $ctrl.getWidgetLink('lease'),
              columnTypes: $ctrl.getWidgetColumnTypesList('lease'),
              widgetDataService: leaseWidgetDataService,
              triggerRefresh: 0,
              isFavorite: false,
              isCollapsed: false
            }, {
              widgetDefaultOrder: 3,
              widgetType: widgetTypes.opportunitiesTable,
              widgetTitleKey: 'emailText',
              widgetExpandToolTipKey: 'email',
              icon: 'email-sms',
              highEngagementDescription: 'emailTextHighEngagementDescription',
              detailViewLinkDisabled: true,
              columnTypes: emailTextOneToOneColumnTypes,
              widgetDataService: function widgetDataService(force) {
                return customerEngagementService.getCustomerEngagementByGroup($ctrl.selectedDealerId, {
                  engagementEventGroupIds: [EngagementEventGroups.email, EngagementEventGroups.text, EngagementEventGroups.autoAssistant],
                  take: MAX_ROWS,
                  hotLeadsOnly: $ctrl.showHotLeadsOnly,
                  notWorkedOnly: $ctrl.showNotWorkedOnly,
                  dealerId: $ctrl.selectedDealerId
                }).then(function (mappedResponse) {
                  return mappedResponse.sort(function (a, b) {
                    return new Date(b.eventDate) - new Date(a.eventDate);
                  });
                });
              },
              triggerRefresh: 0,
              isFavorite: false,
              isCollapsed: false
            }, {
              widgetDefaultOrder: 4,
              widgetType: widgetTypes.opportunitiesTable,
              widgetTitleKey: 'upcomingAppointments',
              widgetExpandToolTipKey: 'upcomingAppointments',
              icon: 'aa-icon-core-calendar-icon-000000',
              highEngagementDescription: 'todaysAppointments',
              detailViewLinkDisabled: true,
              columnTypes: upComingApptColumnTypes,
              widgetDataService: getUpcomingAppointments,
              triggerRefresh: 0,
              isFavorite: false,
              isCollapsed: false
            }, {
              widgetDefaultOrder: 5,
              widgetType: widgetTypes.agenda,
              widgetTitleKey: 'agendaWidgetTitle',
              widgetExpandToolTipKey: 'expandagenda',
              widgetLink: 'activitiesAgenda',
              widgetDataService: agendaWidgetDataService,
              triggerRefresh: 0,
              isFavorite: false,
              isCollapsed: false
            }, {
              widgetDefaultOrder: 6,
              widgetType: widgetTypes.opportunitiesTable,
              widgetTitleKey: 'recentlyAssignedWidgetTitle',
              widgetExpandToolTipKey: 'expandrecentlyAssigned',
              widgetDataService: recentlyAssignedWidgetDataService,
              detailViewLinkDisabled: true,
              columnTypes: ['opportunity', 'alertBlocks', 'assignedDate'],
              triggerRefresh: 0,
              isFavorite: false,
              isCollapsed: false
            }, {
              widgetDefaultOrder: 7,
              widgetType: widgetTypes.opportunitiesTable,
              widgetTitleKey: 'service',
              widgetExpandToolTipKey: 'service',
              icon: 'aa-icon-service-drive',
              highEngagementDescription: 'serviceHighEngagementDescription',
              detailViewLinkDisabled: true,
              columnTypes: serviceColumnTypes,
              widgetDataService: function widgetDataService(force) {
                return customerEngagementService.getCustomerEngagementByGroup($ctrl.selectedDealerId, {
                  engagementEventGroupIds: [EngagementEventGroups.service],
                  take: MAX_ROWS,
                  hotLeadsOnly: $ctrl.showHotLeadsOnly,
                  notWorkedOnly: $ctrl.showNotWorkedOnly,
                  dealerId: $ctrl.selectedDealerId
                });
              },
              triggerRefresh: 0,
              isFavorite: false,
              isCollapsed: false
            }, {
              widgetDefaultOrder: 8,
              widgetType: widgetTypes.opportunitiesTable,
              widgetTitleKey: 'oneToOne',
              widgetExpandToolTipKey: 'oneToOne',
              icon: 'marketing-mailer-icon-white',
              highEngagementDescription: 'o2oHighEngagementDescription',
              detailViewLinkDisabled: true,
              columnTypes: emailTextOneToOneColumnTypes,
              widgetDataService: function widgetDataService(force) {
                return customerEngagementService.getCustomerEngagementByGroup($ctrl.selectedDealerId, {
                  engagementEventGroupIds: [EngagementEventGroups.one2one, EngagementEventGroups.intelligentMarketing],
                  take: MAX_ROWS,
                  hotLeadsOnly: $ctrl.showHotLeadsOnly,
                  notWorkedOnly: $ctrl.showNotWorkedOnly,
                  dealerId: $ctrl.selectedDealerId
                });
              },
              triggerRefresh: 0,
              isFavorite: false,
              isCollapsed: false
            }, {
              widgetDefaultOrder: 9,
              widgetType: widgetTypes.opportunitiesTable,
              widgetTitleKey: 'web',
              widgetExpandToolTipKey: 'web',
              icon: 'web',
              highEngagementDescription: 'webHighEngagementDescription',
              detailViewLinkDisabled: true,
              columnTypes: webColumnTypes,
              widgetDataService: function widgetDataService(force) {
                return customerEngagementService.getCustomerEngagementByGroup($ctrl.selectedDealerId, {
                  engagementEventGroupIds: [EngagementEventGroups.web],
                  take: MAX_ROWS,
                  hotLeadsOnly: $ctrl.showHotLeadsOnly,
                  notWorkedOnly: $ctrl.showNotWorkedOnly,
                  dealerId: $ctrl.selectedDealerId
                });
              },
              triggerRefresh: 0,
              isFavorite: false,
              isCollapsed: false
            }];
            _context.n = 1;
            return dealerService.getIsAssetEnabledForDealer(assetTypes.reviewBuilderPro, $ctrl.selectedDealerId);
          case 1:
            $ctrl.showReviewPro = _context.v;
            if ($ctrl.showReviewPro === true) {
              $ctrl.widgets.push({
                widgetDefaultOrder: 10,
                widgetType: widgetTypes.opportunitiesTable,
                widgetTitleKey: 'reviews',
                widgetExpandToolTipKey: '',
                icon: 'reviews',
                highEngagementDescription: '',
                detailViewLinkDisabled: true,
                columnTypes: reviewProColumnTypes,
                widgetDataService: function widgetDataService(force) {
                  return customerEngagementService.getCustomerEngagementByGroup($ctrl.selectedDealerId, {
                    engagementEventGroupIds: [EngagementEventGroups.reviews],
                    take: MAX_ROWS,
                    hotLeadsOnly: 0,
                    notWorkedOnly: $ctrl.showNotWorkedOnly,
                    dealerId: $ctrl.selectedDealerId
                  });
                },
                triggerRefresh: 0,
                isFavorite: false,
                isCollapsed: false
              });
            }
            _context.n = 2;
            return dealerService.getIsAssetEnabledForDealer(assetTypes.geoAlert, $ctrl.selectedDealerId);
          case 2:
            $ctrl.showGeoAlert = _context.v;
            if ($ctrl.showGeoAlert === true) {
              $ctrl.widgets.push({
                widgetDefaultOrder: 11,
                widgetType: widgetTypes.opportunitiesTable,
                widgetTitleKey: 'geoAlert',
                widgetExpandToolTipKey: 'geoAlert',
                icon: 'geo-alert-icon-white',
                highEngagementDescription: 'geoAlertTypeActive',
                detailViewLinkDisabled: true,
                columnTypes: geoAlertColumnTypes,
                widgetDataService: function widgetDataService(force) {
                  return customerEngagementService.getCustomerEngagementByGroup($ctrl.selectedDealerId, {
                    engagementEventGroupIds: [EngagementEventGroups.geoAlert],
                    take: MAX_ROWS,
                    hotLeadsOnly: $ctrl.showHotLeadsOnly,
                    notWorkedOnly: $ctrl.showNotWorkedOnly,
                    dealerId: $ctrl.selectedDealerId
                  });
                },
                triggerRefresh: 0,
                isFavorite: false,
                isCollapsed: false
              });
            }

            // Get favorites from localstorage and re-order:
            showFavorites();
            showCollapseState();
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _setUpWidgets.apply(this, arguments);
  }
  function showCollapseState() {
    var widgetStr = storageService.getItem('localPriorityCollapseState_' + $ctrl.userId);
    if (widgetStr != null) {
      var widgetList = widgetStr.split(",");
      widgetList.forEach(function (widget) {
        var widgetSetting = widget.split(":");
        var index = widgetSetting[0];
        var collapseState = widgetSetting[1];
        var widgetIndex = _.findIndex($ctrl.widgets, {
          widgetDefaultOrder: parseInt(index)
        });
        if (widgetIndex >= 0) {
          $ctrl.widgets[widgetIndex].isCollapsed = collapseState == "1" ? true : false;
        }
      });
    }
  }
  function showFavorites() {
    var favoritesStr = storageService.getItem('localPriorityDashFavs_' + $ctrl.userId);
    if (favoritesStr != null) {
      $ctrl.widgets.sort(byDefaultOrder);
      var favorites = favoritesStr.split(",");
      for (var i = favorites.length - 1; i >= 0; i--) {
        var index = _.findIndex($ctrl.widgets, {
          widgetDefaultOrder: parseInt(favorites[i])
        });
        if (index > 0) {
          $ctrl.widgets[index].isFavorite = true;
          moveWidgetToTop(index);
        }
      }
    }
  }
  function byDefaultOrder(object1, object2) {
    if (object1.widgetDefaultOrder < object2.widgetDefaultOrder) return -1;
    if (object1.widgetDefaultOrder > object2.widgetDefaultOrder) return 1;
    return 0;
  }
  function setFavoriteWidget(index, isOn) {
    // get index from order field:
    var widgetIndex = _.findIndex($ctrl.widgets, {
      widgetDefaultOrder: index
    });
    if (!isOn) {
      $ctrl.widgets[widgetIndex].isFavorite = false;
    } else {
      $ctrl.widgets[widgetIndex].isFavorite = true;
      moveWidgetToTop(widgetIndex);
    }
    saveFavorites();
    showFavorites();
  }
  function saveCollapseState(index, isCollapsed) {
    var collapseState = "";
    var widgetIndex = _.findIndex($ctrl.widgets, {
      widgetDefaultOrder: index
    });
    $ctrl.widgets[widgetIndex].isCollapsed = isCollapsed;
    $ctrl.widgets.forEach(function (widget) {
      collapseState = collapseState + "," + widget.widgetDefaultOrder + ":" + (widget.isCollapsed ? "1" : "0");
    });
    storageService.setItem('localPriorityCollapseState_' + $ctrl.userId, collapseState.substring(1));
  }
  function saveFavorites() {
    var favorites = "";
    $ctrl.widgets.forEach(function (widget) {
      if (widget.isFavorite) {
        favorites = favorites + "," + widget.widgetDefaultOrder;
      }
    });
    storageService.setItem('localPriorityDashFavs_' + $ctrl.userId, favorites.substring(1));
  }
  function moveWidgetToTop(from) {
    $ctrl.widgets.splice(0, 0, $ctrl.widgets.splice(from, 1)[0]);
  }
  function init() {
    authorizationService.getDealSheetPermissions().then(function (data) {
      $ctrl.permissions = data;
    });
  }
  function $onChanges(changes) {
    if (changes.selectedDealerId) {
      setUpWidgets().then(function (result) {
        if (!changes.selectedDealerId.isFirstChange()) {
          refreshWidgets();
        }
      });
    }
  }
  function closeCallback(type) {
    //refresh
    switch (type) {
      case widgetTypes.lease:
      case widgetTypes.retail:
      case widgetTypes.newOpportunityChanges:
        $ctrl.refreshWidgets();
        break;
      case widgetTypes.agenda:
      case widgetTypes.recentlyAssigned:
      default:
        break;
    }
  }
  function refreshWidgets() {
    var _iterator = _createForOfIteratorHelper($ctrl.widgets),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var widget = _step.value;
        widget.triggerRefresh++;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  function filtersChanged() {
    refreshWidgets();
  }
  function getWidgetLink(type) {
    if (isEuroLite) return 'euroliteopportunities';
    switch (type) {
      case 'lease':
        return 'opportunitiesLease';
      case 'retail':
        return 'opportunitiesRetail';
    }
  }
  function getWidgetColumnTypesList(type) {
    switch (type) {
      case 'lease':
        if (isEuroLite) return ['opportunity', 'alertBlocks'];else return ['opportunity', 'alertBlocks', 'apptOrRoDate', 'lease'];
      case 'retail':
        if (isEuroLite) return ['opportunity', 'alertBlocks'];else return ['opportunity', 'alertBlocks', 'apptOrRoDate', 'retail'];
      default:
        return ['opportunity', 'alertBlocks', 'apptOrRoDate'];
    }
  }
  function leaseWidgetDataService(flushCache) {
    return searchService.getOpenOpportunities($ctrl.selectedDealerId, $ctrl.leaseSaleTypes, flushCache);
  }
  function retailWidgetDataService(flushCache) {
    return searchService.getOpenOpportunities($ctrl.selectedDealerId, $ctrl.retailSaleTypes, flushCache);
  }
  function recentlyAssignedWidgetDataService(flushCache) {
    return searchService.getRecentlyAssignedOpportunities($ctrl.selectedDealerId, flushCache);
  }
  function agendaWidgetDataService(flushCache) {
    return activityService.getAgendaItems($ctrl.selectedDealerId, null, flushCache);
  }
  function getUpcomingAppointments() {
    // This ought to be the _dealer's_ time zone, not the user's, but we
    // don't have that info. We fall back to the browser's time zone if the
    // profile's time zone is not set.
    var timeZone = TimeZonesById[storageService.getItem('timezoneId')] || guessBrowserTimeZone();
    var now = moment();
    var startOfToday = now.clone().tz(timeZone.tzdbName).startOf('day');
    var dateTo = startOfToday.clone().add(30, 'days');
    return activityService.getAgendaItemsWithEntityData({
      dateFrom: startOfToday.toDate(),
      dateTo: dateTo.toDate(),
      activityTypes: [ApiActivityTypes.appointment],
      take: MAX_ROWS
    }).then(function (appts) {
      return appts.map(function (appt) {
        return _objectSpread(_objectSpread({}, appt), {}, {
          // Faking the highEngagement flag is easier than editing
          // dashboardOpportunitiesTable so it understands "today"
          highEngagement: moment(appt.dueDate).isSame(now, 'day')
        });
      });
    }).then(function (appts) {
      if ($ctrl.showHotLeadsOnly) {
        return appts.filter(function (appt) {
          return appt.highEngagement;
        });
      } else {
        return appts;
      }
    });
  }
}